import { apiFetch } from './client';

const BASE = '/connector-event-mappings';

/**
 * List connector event mappings (paged). Scoped server-side to the
 * caller's tenant/subscription — no subscription id is sent here.
 * @param {{page?:number,size?:number,signal?:AbortSignal}} [opts]
 */
export const list = ({ page = 0, size = 20, signal } = {}) =>
  apiFetch(`${BASE}?page=${page}&size=${size}`, { signal });

/** Get a connector event mapping by id. */
export const get = (id, { signal } = {}) => apiFetch(`${BASE}/${id}`, { signal });

/**
 * Create a connector event mapping. Requires bluestream_event_type and at
 * least one step. Do not send connector_subscription_id — the server derives
 * it from the caller's tenant. Do not send vendor_action_name at the mapping
 * level either — the server derives it from the EMIT_EVENT step's params, so
 * sending it there is silently ignored.
 */
export const create = (body, { signal } = {}) =>
  apiFetch(BASE, { method: 'POST', body: JSON.stringify(body), signal });

/** Partial-update a connector event mapping. Absent fields are left untouched. */
export const update = (id, body, { signal } = {}) =>
  apiFetch(`${BASE}/${id}`, { method: 'PATCH', body: JSON.stringify(body), signal });

/** Delete a connector event mapping. */
export const remove = (id, { signal } = {}) =>
  apiFetch(`${BASE}/${id}`, { method: 'DELETE', signal });
